import { useEffect } from 'react';
import { ICustomFont } from '@typings/setting/fontManager';

const STYLE_TAG_ID = 'custom-fonts-style';

export function useCustomFonts(customFonts?: ICustomFont[]) {
  useEffect(() => {
    const existingTag = document.getElementById(STYLE_TAG_ID);

    if (!customFonts || customFonts.length === 0) {
      if (existingTag) {
        existingTag.remove();
      }
      return;
    }

    const newCss = customFonts.map((font) => font.cssText).join('\n\n');

    // 내용이 동일하면 불필요한 삭제/재생성 생략 (Firestore snapshot으로 인한 폰트 깜빡임 방지)
    if (existingTag && existingTag.textContent === newCss) {
      return;
    }

    const styleTag = document.createElement('style');
    styleTag.id = STYLE_TAG_ID;
    styleTag.textContent = newCss;

    if (existingTag) {
      existingTag.replaceWith(styleTag);
    } else {
      document.head.appendChild(styleTag);
    }

    return () => {
      styleTag.remove();
    };
  }, [customFonts]);
}

